import React from "react";
import { LuCheck, LuCloudOff } from "react-icons/lu";
import { Spinner } from "./Spinner";
import { formatDate, t } from "../../i18n";
import type { SaveStatus as Status } from "../../hooks/useAutoSave";

interface SaveStatusProps {
  status: Status;
  savedAt: Date | null;
  className?: string;
}

/** Indicador discreto do autosave: "Salvando…", "Salvo às 14:32", "Não foi salvo". */
export const SaveStatus: React.FC<SaveStatusProps> = ({ status, savedAt, className = "" }) => (
  <span role="status" aria-live="polite" className={`inline-flex items-center gap-1.5 text-caption ${status === "error" ? "text-danger" : "text-fg-subtle"} ${className}`}>
    {status === "saving" && <><Spinner size={12} /> {t("autosave.saving")}</>}
    {status === "saved" && savedAt && <><LuCheck aria-hidden /> {t("autosave.saved", { time: formatDate(savedAt, { timeStyle: "short" }) })}</>}
    {status === "error" && <><LuCloudOff aria-hidden /> {t("autosave.error")}</>}
  </span>
);
